import type { DocumentLanguage } from './files.ts';
export type DocumentWord = { text: string; x: number; y: number; width: number; height: number; confidence: number | null };
export type DocumentPage = { page: number; total: number; method: 'text' | 'ocr'; width: number; height: number; text: string; words: DocumentWord[]; confidence: number | null };
export type DocumentExtraction = { version: 1; language: DocumentLanguage; pages: DocumentPage[]; warnings: string[] };
/** A common reading order for PDF text cells and OCR words. Originals stay authoritative. */
export function documentRows(words: DocumentWord[]) {
  const rows: { y: number; height: number; words: DocumentWord[] }[] = [];
  for (const word of [...words].filter(w => w.text.trim()).sort((a, b) => a.y - b.y || a.x - b.x)) {
    const row = rows.slice(-8).reverse().find(r => Math.abs(r.y - word.y) <= Math.max(2, Math.min(r.height, word.height) * .45));
    if (row) row.words.push(word); else rows.push({ y: word.y, height: word.height, words: [word] });
  }
  return rows.sort((a, b) => a.y - b.y).map(r => r.words.sort((a, b) => a.x - b.x));
}
export const documentPageText = (words: DocumentWord[]) => documentRows(words).map(row => row.map(w => w.text).join(' ')).join('\n');
